export default {
  'CONTACT_STATUS': (state, status) => {
    state.contactStatus = status
  }
};
